import { Injectable } from '@angular/core';
import { Environment } from '@r1-compass-library/environments/environment';
import { LifecycleRulesetFolder } from '@r1-compass-library/models';
import { FolderRestService } from './rest/folder-rest.service';
import { BasicFolderSearch } from '@r1-compass-library/models/search/basic-folder-search.model';

@Injectable({ providedIn: 'root' })
export class LifecycleRulesetFolderService extends FolderRestService<LifecycleRulesetFolder, BasicFolderSearch> {
    protected override BASE_URL: string = Environment.baseUrl + '/frontend/lifecycle-ruleset-folders';
    protected override TARGET_OBJECT = 'lifecycle-ruleset folder';

    processNamePrefix = 'LifecycleRulesetFolderService';
}
